import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { getcomponenteAmbiental, fauna } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const ComponenteAmbiental = ({ municipioId, onPageChange }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [dataFauna, setDataFauna] = useState([]);
    const [municipioNombre, setMunicipioNombre] = useState('');

    useEffect(() => {
        if (municipioId) {
            fetchData();
            fetchDataFauna();
        }

    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getcomponenteAmbiental(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                    setMunicipioNombre(response.data[0]?.municipio || 'Desconocido');
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDataFauna = async () => {
        setLoading(true);
        try {
            const response = await fauna(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setDataFauna(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading fauna data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const renderFaunaTable = () => {
        const columns = [
            { title: 'Aves', dataIndex: 'aves', className: 'filaP', key: 'aves' },
            { title: 'Mamíferos', dataIndex: 'maniferos', className: 'filaP', key: 'maniferos' },
            { title: 'Anfibios', dataIndex: 'anfibios', className: 'filaP', key: 'anfibios' },
            { title: 'Reptiles', dataIndex: 'reptiles', className: 'filaP', key: 'reptiles' },
            { title: 'Total de Especies', dataIndex: 'total_especies', className: 'filaP', key: 'total_especies' },
        ];

        return (
            <Table
                dataSource={dataFauna}
                columns={columns}
                rowKey="idinformacion"
                pagination={false}
                bordered
                footer={() => (
                    <div className="table-footer">
                        {dataFauna.length > 0 && dataFauna[0]?.fuente && (
                            <p>{dataFauna[0].fuente}</p>
                        )}
                    </div>
                )}
            />
        );
    };



    return (
        <div className="page-content">
            {loading ? (
                <Spin size="large" />
            ) : data.length > 0 ? (
                data.map(item => (
                    <div key={item.idinformacion}>
                        <div className="section">
                            <h3>Hidrografía</h3>
                            <p style={{ columnCount: 2, columnGap: '30px' }}> {item.hidrografia}</p>
                            <p>{item.fuente_s}</p>
                        </div>
                        <div className="section">
                            <h3>Seuelo</h3>
                            <p style={{ columnCount: 2, columnGap: '30px' }}>{item.desc_suelo}</p>
                            <p>{item.fuente_s}</p>
                        </div>
                        <div className="section">
                            <h3>Fauna</h3>
                            <p style={{ columnCount: 2, columnGap: '30px' }}>{item.fauna}</p>
                            <p>{item.fuente_min}</p>
                        </div>

                        {renderFaunaTable()}

                        <div className="section">
                            <h3>Flora</h3>
                            <div style={{ columnCount: 2, columnGap: '30px' }} dangerouslySetInnerHTML={{ __html: item.flora }} />
                            <p> {item.fuente_flora}</p>
                        </div>
                    </div>
                ))
            ) : (
                <p>No hay datos disponibles para este municipio.</p>
            )}
        </div>
    );
};

export default ComponenteAmbiental;
